import { HTMLAttributes } from "react";

export default function InteriaJS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2332_1839)">
        <path
          d="M13.8029 11H0L13.3376 24.3376L0 37.6752H13.8029L27.1405 24.3376L13.8029 11Z"
          fill="#875CE2"
        />
        <path
          d="M34.6625 11H20.8596L34.1972 24.3376L20.8596 37.6752H34.6625L48.0001 24.3376L34.6625 11Z"
          fill="#875CE2"
        />
      </g>
      <defs>
        <clipPath id="clip0_2332_1839">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
